import { render, staticRenderFns } from "./AcoesProcessoDigital.vue?vue&type=template&id=6f12494a&scoped=true"
import script from "./AcoesProcessoDigital.vue?vue&type=script&lang=js"
export * from "./AcoesProcessoDigital.vue?vue&type=script&lang=js"
import style0 from "./AcoesProcessoDigital.vue?vue&type=style&index=0&id=6f12494a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f12494a",
  null
  
)

export default component.exports